"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ResponsiveDesign: ['responsive-design', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.5,12a1,1,0,0,0,1-1V7.088A2.548,2.548,0,0,0,19,4.5H8.5a1,1,0,0,0,0,2H19a.551.551,0,0,1,.5.588V11A1,1,0,0,0,20.5,12Z', 'M10.75,18.5a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H9a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2H13.25a.25.25,0,0,1-.25-.25v-2a.25.25,0,0,1,.25-.25H15.5A.5.5,0,0,0,16,18V15.889a2.757,2.757,0,0,1,.105-.754.5.5,0,0,0-.482-.635H5a.5.5,0,0,1-.5-.5V12.5a1,1,0,0,0-2,0v3.412A2.548,2.548,0,0,0,5,18.5Z', 'M1.833,9.75H5.167A1.613,1.613,0,0,0,6.75,8.111V1.889A1.613,1.613,0,0,0,5.167.25H1.833A1.613,1.613,0,0,0,.25,1.889V8.111A1.613,1.613,0,0,0,1.833,9.75ZM1.75,1.889c0-.085.055-.139.083-.139H5.167c.028,0,.083.054.083.139V8.111c0,.085-.055.139-.083.139H1.833c-.028,0-.083-.054-.083-.139Z', 'M18.833,14.25a1.613,1.613,0,0,0-1.583,1.639V22.25a1.545,1.545,0,0,0,1.583,1.5h3.334a1.545,1.545,0,0,0,1.583-1.5V15.889a1.613,1.613,0,0,0-1.583-1.639Zm3.417,1.639V21a.25.25,0,0,1-.25.25H19a.25.25,0,0,1-.25-.25V15.889c0-.085.055-.139.083-.139h3.334C22.2,15.75,22.25,15.8,22.25,15.889Z']],
  ResponsiveDesignExpand: ['responsive-design-expand', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.668,10.418a1,1,0,1,0,1.414,1.414l1.793-1.793a.5.5,0,0,1,.707,0l.439.44a.5.5,0,0,0,.854-.354v-3a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.354.854l.44.439a.5.5,0,0,1,0,.707Z', 'M10.729,7.479a.5.5,0,0,0-.354-.854h-3a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.309.462.5.5,0,0,0,.545-.108l.439-.44a.5.5,0,0,1,.707,0l1.793,1.793a1,1,0,0,0,1.414-1.414L10.289,8.625a.5.5,0,0,1,0-.707Z', 'M15.875,16.125a1,1,0,0,0,1,1h4a3,3,0,0,0,3-3v-11a3,3,0,0,0-3-3h-16a3,3,0,0,0-3,3v7.5a1,1,0,0,0,2,0v-5a1,1,0,0,1,1-1h16a1,1,0,0,1,1,1v8.5a1,1,0,0,1-1,1h-4A1,1,0,0,0,15.875,16.125Zm-10.5-12.5a1,1,0,0,1-1-1,.979.979,0,0,1,.092-.408,1,1,0,0,1,.908-.592.985.985,0,0,1,.846.5.969.969,0,0,1,.154.5A1,1,0,0,1,5.375,3.625Zm3.5,0a1,1,0,0,1-1-1,.969.969,0,0,1,.154-.5.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A1,1,0,0,1,8.875,3.625Zm3.5,0a1,1,0,0,1-1-1,.969.969,0,0,1,.154-.5.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A1,1,0,0,1,12.375,3.625Z', 'M2.875,12.875a2.753,2.753,0,0,0-2.75,2.75v5.5a2.752,2.752,0,0,0,2.75,2.75h8.5a2.752,2.752,0,0,0,2.75-2.75v-5.5a2.753,2.753,0,0,0-2.75-2.75Zm-1.25,4.25a.5.5,0,0,1,.5-.5h10a.5.5,0,0,1,.5.5v4a1.251,1.251,0,0,1-1.25,1.25h-8.5a1.251,1.251,0,0,1-1.25-1.25Z']],
  ResponsiveDesignLaptop: ['responsive-design-laptop', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2a2,2,0,0,0-2-2H16.5a2,2,0,0,0-2,2V8.25a.25.25,0,0,1-.25.25h-4A.25.25,0,0,1,10,8.25V2A2,2,0,0,0,8,0H2A2,2,0,0,0,0,2V13.5a2,2,0,0,0,2,2H8a2,2,0,0,0,2-2V10.75a.25.25,0,0,1,.25-.25h4a.25.25,0,0,1,.25.25V13.5a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2ZM7.5,2a.5.5,0,0,1,.5.5v8a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1-.5-.5v-8A.5.5,0,0,1,2.5,2ZM4,13.5a.5.5,0,0,1,0-1H6a.5.5,0,0,1,0,1Zm18-.25a.25.25,0,0,1-.25.25h-5a.25.25,0,0,1-.25-.25v-11A.25.25,0,0,1,16.75,2h5a.25.25,0,0,1,.25.25Z', 'M21.5,20h-.75a.25.25,0,0,1-.25-.25V17.5a1,1,0,0,0-2,0v2.25a.25.25,0,0,1-.25.25H13.5a.489.489,0,0,0-.5.479,1,1,0,1,1-2,0A.489.489,0,0,0,10.5,20H5.75a.25.25,0,0,1-.25-.25V17.5a1,1,0,0,0-2,0v2.25a.25.25,0,0,1-.25.25H2.5a.5.5,0,0,0-.5.5v1A2.5,2.5,0,0,0,4.5,24h15A2.5,2.5,0,0,0,22,21.5v-1A.5.5,0,0,0,21.5,20Z']],
  ResponsiveDesignCursor: ['responsive-design-cursor', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.75,18.113a3,3,0,0,0,3-3v-1.5a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5v3.5A1,1,0,0,0,17.75,18.113Z', 'M6.25,18.113a1,1,0,0,0,0-2h-.5a.5.5,0,0,1-.5-.5v-9a.5.5,0,0,1,.5-.5h7.5a1,1,0,0,0,0-2H3.75a3,3,0,0,0-3,3v8a3,3,0,0,0,3,3Z', 'M23.25,3.113a2,2,0,0,0-2-2h-3a2,2,0,0,0-2,2v6.5a2,2,0,0,0,2,2h3a2,2,0,0,0,2-2Zm-5,.25a.25.25,0,0,1,.25-.25H21a.25.25,0,0,1,.25.25v4.5a.25.25,0,0,1-.25.25H18.5a.25.25,0,0,1-.25-.25Z', 'M16.458,22.594a1,1,0,0,0,0-1.414L13.71,18.432a.247.247,0,0,1-.069-.224.25.25,0,0,1,.147-.182l.963-.413a.5.5,0,0,0-.039-.933l-5.3-1.769a.5.5,0,0,0-.632.633l1.768,5.3a.5.5,0,0,0,.933.039l.413-.962a.249.249,0,0,1,.406-.078l2.748,2.747a1,1,0,0,0,1.414,0Z']],
  ResponsiveDesign1: ['responsive-design-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.625,13.375a1.752,1.752,0,0,0,1.75,1.75h6.5a1.752,1.752,0,0,0,1.75-1.75v-10a1.752,1.752,0,0,0-1.75-1.751h-1.5a.75.75,0,0,0-.75.749v1.5a.751.751,0,0,0,.75.751h1.5a.25.25,0,0,1,.25.25v7a.25.25,0,0,1-.25.25h-7.5a.75.75,0,0,0-.75.75Z', 'M7.124,1.875A1.752,1.752,0,0,0,5.374.125h-3.5a1.752,1.752,0,0,0-1.75,1.75v7a1.752,1.752,0,0,0,1.75,1.75h3.5a1.752,1.752,0,0,0,1.75-1.75Zm-1.5,5.5a.25.25,0,0,1-.25.25h-3.5a.25.25,0,0,1-.25-.25v-5.5a.25.25,0,0,1,.25-.25h3.5a.25.25,0,0,1,.25.25Z', 'M13.875,7.375a1,1,0,0,0,1,1h6.75a.25.25,0,0,1,.25.25v7.5a.25.25,0,0,1-.25.25H7.374a1,1,0,0,0-1,1v1a2,2,0,0,0,2,2h5.25a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25h-2.25a1,1,0,0,0,0,2h7a1,1,0,0,0,0-2h-2.25a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.25-.25h5.75a2,2,0,0,0,2-2v-10a2,2,0,0,0-2-2h-7A1,1,0,0,0,13.875,7.375Z']],
  ResponsiveDesignExpand1: ['responsive-design-expand-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.687,18.962a.5.5,0,0,0,.544-.108l2.123-2.121a.5.5,0,0,0,0-.708L20.231,13.9a.5.5,0,0,0-.853.354v.871a.25.25,0,0,1-.25.25H16.343a1,1,0,0,0,0,2h2.785a.25.25,0,0,1,.25.25V18.5A.5.5,0,0,0,19.687,18.962Z', 'M3.121,13a1,1,0,0,0,1-1V9.215a.25.25,0,0,1,.25-.25h.871A.5.5,0,0,0,5.6,8.111L3.475,5.989a.516.516,0,0,0-.707,0L.646,8.111A.5.5,0,0,0,1,8.965h.871a.25.25,0,0,1,.25.25V12A1,1,0,0,0,3.121,13Z', 'M24,3a3,3,0,0,0-3-3H5A3,3,0,0,0,2,3V4A1,1,0,0,0,3,5H21.5a.5.5,0,0,1,.5.5v7a1,1,0,0,0,2,0ZM6.346,3A.966.966,0,0,1,4.654,3,.969.969,0,0,1,4.5,2.5a.979.979,0,0,1,.092-.408A1,1,0,0,1,5.5,1.5a.985.985,0,0,1,.846.5.969.969,0,0,1,.154.5A.969.969,0,0,1,6.346,3Zm3.5,0A.966.966,0,0,1,8.154,3,.969.969,0,0,1,8,2.5.969.969,0,0,1,8.154,2,.966.966,0,0,1,9.846,2,.969.969,0,0,1,10,2.5.969.969,0,0,1,9.846,3Zm3.5,0a.966.966,0,0,1-1.692,0,.969.969,0,0,1-.154-.5.969.969,0,0,1,.154-.5.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5A.969.969,0,0,1,13.346,3Z', 'M13,16.75A2.753,2.753,0,0,0,10.25,14H2.75A2.753,2.753,0,0,0,0,16.75v4.5A2.752,2.752,0,0,0,2.75,24h7.5A2.752,2.752,0,0,0,13,21.25ZM1.5,21.25v-3a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5v3a1.251,1.251,0,0,1-1.25,1.25H2.75A1.251,1.251,0,0,1,1.5,21.25Z']],
  ResponsiveDesignPhone: ['responsive-design-phone', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.875,22.25A1.752,1.752,0,0,0,2.625,24h5a1.752,1.752,0,0,0,1.75-1.75v-2a.75.75,0,0,0-1.5,0v.5a.25.25,0,0,1-.25.25h-5a.25.25,0,0,1-.25-.25v-5a.25.25,0,0,1,.25-.25h2.5a.75.75,0,0,0,.75-.749v-1.5a.751.751,0,0,0-.75-.751h-2.5a1.752,1.752,0,0,0-1.75,1.75Z', 'M14.271,13.854a.5.5,0,0,0,.854-.354v-3a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.354.854l.617.616a.25.25,0,0,1,0,.353l-2.94,2.94a.25.25,0,0,1-.353,0l-.616-.616a.5.5,0,0,0-.854.353v3a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.354-.853l-.617-.617a.25.25,0,0,1,0-.353l2.94-2.94a.25.25,0,0,1,.353,0Z', 'M9.125,7.5a1,1,0,0,0,2,0V4.25a.25.25,0,0,1,.25-.25h9.5a.25.25,0,0,1,.25.25v9.5a.25.25,0,0,1-.25.25h-4.75a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h5a2,2,0,0,0,2-2V2a2,2,0,0,0-2-2h-10a2,2,0,0,0-2,2Z']],
  ResponsiveDesignImage: ['responsive-design-image', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.482,13.75a.556.556,0,0,0-.466.2L11.3,16.464a.5.5,0,0,1-.726.109L8.951,15.267a.641.641,0,0,0-.423-.119.566.566,0,0,0-.39.161l-1.89,2.107a.5.5,0,0,0,.372.834h9a.5.5,0,0,0,.43-.756L13.935,13.96A.537.537,0,0,0,13.482,13.75Z', 'M4.500 12.250 A1.500 1.500 0 1 0 7.500 12.250 A1.500 1.500 0 1 0 4.500 12.250 Z', 'M0,19.25a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3v-4.5a1,1,0,0,0-2,0v4.5a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1v-10a1,1,0,0,1,1-1H15a.5.5,0,0,0,.5-.5V4.25a.5.5,0,0,0-.5-.5H3a3,3,0,0,0-3,3ZM9.654,5.75a.966.966,0,0,1,1.692,0,.969.969,0,0,1,.154.5,1,1,0,0,1-2,0A.969.969,0,0,1,9.654,5.75Zm-3.5,0a.966.966,0,0,1,1.692,0A.969.969,0,0,1,8,6.25a1,1,0,0,1-2,0A.969.969,0,0,1,6.154,5.75Zm-3.562.092A1,1,0,0,1,3.5,5.25a.985.985,0,0,1,.846.5.969.969,0,0,1,.154.5,1,1,0,0,1-2,0A.979.979,0,0,1,2.592,5.842Z', 'M19,1.75a2,2,0,0,0-2,2v6.5a2,2,0,0,0,2,2h3a2,2,0,0,0,2-2V3.75a2,2,0,0,0-2-2ZM22,8.5a.25.25,0,0,1-.25.25h-2.5A.25.25,0,0,1,19,8.5V4a.25.25,0,0,1,.25-.25h2.5A.25.25,0,0,1,22,4Z']],
  ResponsiveDesignHand: ['responsive-design-hand', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.5,12a.25.25,0,0,0-.25.25V16a1,1,0,0,0,1,1h.5a3,3,0,0,0,3-3V12.25A.25.25,0,0,0,20.5,12Z', 'M13.243,13.5a1.5,1.5,0,0,0-3,0V21a.25.25,0,0,1-.442.161l-1.278-1.53a1.042,1.042,0,0,0-.8-.367l-1,.017a.976.976,0,0,0-.861,1.438L7.6,23.87A.249.249,0,0,0,7.822,24H18.528a.249.249,0,0,0,.247-.212l.468-3.067a.95.95,0,0,0-.59-.971l-5.245-1.882a.25.25,0,0,1-.165-.235Z', 'M23.25,2a2,2,0,0,0-2-2h-3a2,2,0,0,0-2,2V8.5a2,2,0,0,0,2,2h3a2,2,0,0,0,2-2Zm-5,.25A.25.25,0,0,1,18.5,2H21a.25.25,0,0,1,.25.25v4.5A.25.25,0,0,1,21,7H18.5a.25.25,0,0,1-.25-.25Z', 'M7.25,17a1,1,0,0,0,0-2H5.75a.5.5,0,0,1-.5-.5v-9a.5.5,0,0,1,.5-.5h7.5a1,1,0,0,0,0-2H3.75a3,3,0,0,0-3,3v8a3,3,0,0,0,3,3Z']],
  ResponsiveDesignLaptop1: ['responsive-design-laptop-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5,20h-.75a.25.25,0,0,1-.25-.25V17.5a1,1,0,0,0-2,0v2.25a.25.25,0,0,1-.25.25H11.5a.489.489,0,0,0-.5.479,1,1,0,1,1-2,0A.489.489,0,0,0,8.5,20H3.75a.25.25,0,0,1-.25-.25V16a1,1,0,0,0-2,0v3.75a.25.25,0,0,1-.25.25H.5a.5.5,0,0,0-.5.5v1A2.5,2.5,0,0,0,2.5,24h15A2.5,2.5,0,0,0,20,21.5v-1A.5.5,0,0,0,19.5,20Z', 'M5.5,15.5H11a2,2,0,0,0,2-2V2a2,2,0,0,0-2-2H5.5a2,2,0,0,0-2,2V13.5A2,2,0,0,0,5.5,15.5ZM5.75,2h5a.25.25,0,0,1,.25.25v11a.25.25,0,0,1-.25.25h-5a.25.25,0,0,1-.25-.25v-11A.25.25,0,0,1,5.75,2Z', 'M22,0H16a2,2,0,0,0-2,2V13.5a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm-.5,2a.5.5,0,0,1,.5.5v8a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1-.5-.5v-8a.5.5,0,0,1,.5-.5ZM18,13.5a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z']]
};
exports["default"] = _default;